import { useRouter } from "next/router"
import styled, { css } from "styled-components"

import Link from "~/components/atoms/Link"
import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import { Color, IsMobile, IsPC, SpacingSize, TextSize, Transition, LineHeight } from "~/consts/style-mixins"
import { internalLink } from "~/services/helper"

const Footer = () => {
  const router = useRouter()

  return (
    <StyledFooter>
      <Container size="Large">
        <StyledFooterUpper>
          <StyledLinkWrapper>
            <StyledLinkTitle type="SubHeading">サービス一覧</StyledLinkTitle>
            <StyledLinkInner>
              <StyledLink href={`${process.env.INFRA_INTERN_URL}/long-internship`}>長期インターン</StyledLink>
              <StyledLink href={internalLink("/events")}>イベント</StyledLink>
            </StyledLinkInner>
          </StyledLinkWrapper>
          <StyledLinkWrapper className="is-last">
            <StyledLinkTitle type="SubHeading">採用担当者様向け</StyledLinkTitle>
            <StyledLinkInner>
              <StyledLink
                href={`${process.env.INFRA_INTERN_URL}/pages/contact-for-corp`}
                className="gtm_footer-long-internship-corp-contact"
              >
                長期インターン採用について
              </StyledLink>
              {/* <StyledLink href={internalLink("/new-grad-scout/corp-contact")}>新卒採用について</StyledLink> */}
            </StyledLinkInner>
          </StyledLinkWrapper>
        </StyledFooterUpper>
        <div>
          <StyledBottomLinkWrapper>
            <StyledBottomLink href={`${process.env.INFRA_INTERN_URL}/pages/user-policy`} rel="nofollow">
              利用規約
            </StyledBottomLink>
            <StyledBottomLink href={`${process.env.INFRA_INTERN_URL}/pages/privacy-policy`} rel="nofollow">
              プライバシーポリシー
            </StyledBottomLink>
            <StyledBottomLink href="https://www.legaseed.co.jp/privacy/" rel="nofollow">
              個人情報保護方針
            </StyledBottomLink>
            <StyledBottomLink href={internalLink("/scta-notation")} rel="nofollow">
              特定商取引法に基づく表記
            </StyledBottomLink>
            <StyledBottomLink href={`${process.env.INFRA_INTERN_URL}/pages/contact`}>お問い合わせ</StyledBottomLink>
            <StyledBottomLink href="https://www.legaseed.co.jp/" target="_blank">
              運営会社
            </StyledBottomLink>
          </StyledBottomLinkWrapper>
          <Copyright type="SubNote">© 2015-{new Date().getFullYear()} Copyright Legaseed Inc.</Copyright>
        </div>
      </Container>
    </StyledFooter>
  )
}

const StyledFooter = styled.div`
  width: 100%;
  background: ${Color.Black};
  padding: ${SpacingSize["3XL"]}px 0;
`
const StyledFooterUpper = styled.div`
  display: flex;
  margin-bottom: ${SpacingSize["3XL"]}px;
  ${IsMobile(css`
    flex-direction: column;
    margin-bottom: 32px;
  `)}
`
const StyledLinkWrapper = styled.div`
  margin-right: 80px;
  ${IsMobile(css`
    margin: 0 0 32px;
  `)}
  &.is-last {
    margin: 0;
  }
`
const StyledLinkTitle = styled(Typography)`
  margin-bottom: ${SpacingSize.L}px;
  color: ${Color.White};
  ${IsMobile(css`
    margin-bottom: 16px;
  `)}
`
const StyledLinkInner = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: -${SpacingSize.S}px;
  ${IsMobile(css`
    flex-direction: initial;
    flex-wrap: wrap;
    margin-right: -16px;
  `)}
`
const StyledLink = styled(Link)`
  color: ${Color.White};
  font-size: ${TextSize.S}px;
  line-height: ${LineHeight.M}%;
  margin: 0 0 ${SpacingSize.S}px;
  ${Transition.Hover};
  &:hover {
    opacity: 0.6;
  }
  ${IsMobile(css`
    width: 50%;
    padding-right: 16px;
  `)}
`
const StyledBottomLinkWrapper = styled.div`
  margin: -${SpacingSize["4XS"]}px -${SpacingSize.XS}px -${SpacingSize["4XS"]}px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`
const StyledBottomLink = styled(Link)`
  color: ${Color.LightGray};
  font-size: ${TextSize.XS}px;
  line-height: ${LineHeight.M}%;
  padding: ${SpacingSize["4XS"]}px ${SpacingSize.XS}px;
  ${Transition.Hover};
  &:hover {
    opacity: 0.6;
  }
`
const Copyright = styled(Typography)`
  color: ${Color.LightGray};
  text-align: center;
  margin-top: ${SpacingSize.XS}px;
`

export default Footer
